// extracted by mini-css-extract-plugin
export default {"riskBanner":"RiskBanner_riskBanner__a51tF","riskBannerUk":"RiskBanner_riskBannerUk__NU6wQ","riskBannerNonUk":"RiskBanner_riskBannerNonUk__5Mmw2"};